import React from 'react';
import SaveBarBase, { type SaveBarProps } from '@/components/SaveBar';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import {
  resetWidget,
  selectFilters,
  selectWidgetView,
} from '@/features/dashboard/dashboardSlice';
import { useUpdateDashboardFiltersMutation } from '@/features/dashboard/apiSlice';
import { useDatasourceId } from '@/hooks';
import { UUID } from '@/types';

export const SaveBar: React.FC<SaveBarProps & { dashboardId: UUID }> = ({
  dashboardId,
  onSave,
  onCancel,
  ...rest
}) => {
  const dispatch = useAppDispatch();
  const datasourceId = useDatasourceId();
  const widgetView = useAppSelector(selectWidgetView);
  const widgetFilters = useAppSelector(selectFilters);
  const [updateFilters, { isSuccess, data }] =
    useUpdateDashboardFiltersMutation();

  React.useEffect(() => {
    if (isSuccess && data) {
      // TODO: remove preventDefault from onSave completely.
      onSave({ preventDefault() {} } as any);
    }
  }, [isSuccess, data]);
  const handleSave = (e: React.MouseEvent) => {
    if (widgetView) {
      updateFilters({
        datasourceId,
        dashboardId,
        body: {
          ...widgetFilters,
          seriesId: widgetView._series,
        },
      });
    } else {
      onSave(e);
    }
  };

  const handleCancel = (e: React.MouseEvent) => {
    dispatch(resetWidget());
    onCancel(e);
  };

  return <SaveBarBase {...rest} onSave={handleSave} onCancel={handleCancel} />;
};
